/**
 * Copies all properties from source to target (deep) and removes any key in target not in source.
 * Useful when fetching an object from server and want to update a reactive object without having
 * to use ref().
 * 
 * @param target 
 * @param source 
 */
export default function cleanAssign(target: Record<string, any>, source: Record<string, any>) {

  // Remove old keys not in source
  for (const key in target) {
    if (!(key in source)) {
      delete target[key];
    }
  }

  // Assign new/updated keys
  for (const key in source) {
    target[key] = source[key];
  }
}
